import { CloseOutlined } from "@ant-design/icons";
import { Button, Form, Select, Row, Col } from "antd";
import { useEffect, useState } from "react";
import TriStateCheckbox from "../../controls/tri-state-checkbox";

const ClientFilter = ({ current, onClose, filterOptions, clientTypeFilter }) => {
  const [item, setItem] = useState({ ...current });
  const [form] = Form.useForm();
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    form.setFieldsValue(current);

    const neededFilters = ["UserIds", "ManagerIds", "hasdeposit", "hasdolg"];
    const dynamicFilters = neededFilters.map(type => {
      const data = current[type];
      const meta = filterOptions.find(o => o.type === type) || {};

      if (type === "hasdeposit" || type === "hasdolg") {
        return {
          type,
          value: data !== undefined ? data : null,
          inputType: "tristate",
          label: type === "hasdeposit" ? "С депозитом" : "С долгом"
        };
      }

      return {
        type,
        value: Array.isArray(data) ? data : data?.value ?? data ?? [],
        options: meta.options ?? [],
        inputType: meta.inputType,
        label: meta.label ?? type
      };
    });
    setFilters(dynamicFilters);
  }, [current, filterOptions]);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    const result = filters.reduce((acc, f) => {
      if (f.type === "hasdeposit" || f.type === "hasdolg") {
        acc[f.type] = f.value;
      } else {
        acc[f.type] = { value: f.value ?? [] };
      }
      return acc;
    }, {});
    
    if (item.Types) {
      result.Types = item.Types;
    }
    
    onClose(result);
  };

  const userFilter = filters.find(f => f.type === "UserIds") || { value: [], options: [] };
  const managerFilter = filters.find(f => f.type === "ManagerIds") || { value: [], options: [] };
  const hasDepositFilter = filters.find(f => f.type === "hasdeposit") || { value: null };
  const hasDolgFilter = filters.find(f => f.type === "hasdolg") || { value: null };

  const updateLocalFilterValue = (type, val) => {
    const currentMeta = filters.find(f => f.type === type) || {};

    setFilters(prev =>
      prev.map(f => f.type === type ? { ...f, value: val } : f)
    );

    if (type === "hasdeposit" || type === "hasdolg") {
      setItem(prev => ({
        ...prev,
        [type]: val
      }));
    } else {
      setItem(prev => ({
        ...prev,
        [type]: {
          type: type,
          value: val,
          inputType: currentMeta.inputType,
          options: currentMeta.options      
        }
      }));
    }
  };

  const getClientTypeHint = (value) => {
    switch (value) {
      case 0: return "Нет фильтра";
      case 1: return "Есть активированные абонементы";
      case 2: return "Есть неактивированные абонементы";
      case 3: return "Нет визитов по активированным абонементам за последние 30 дней";
      case 4: return "Есть более одного активированного абонемента, пакета";
      case 5: return "Нет проданных абонементов ";
      default: return "";
    }
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр клиентов</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }}/>
          </div>
          <Form form={form} onValuesChange={onValuesChange} colon={false} labelCol={{span: 7}} wrapperCol={{ }} layout={"inline"} >
            <Form.Item name="Types" label="Тип клиента" className="client-filter-select"> 
              <Select
                className="client-filter-select"
                mode="multiple"
                options={clientTypeFilter.map((opt) => ({
                  ...opt,
                  label: (
                    <span title={getClientTypeHint(opt.value)}>
                      {opt.label}
                    </span>
                  ),
                }))}
              />
            </Form.Item>
            <Form.Item label="C депозитом" className="client-filter-form-item">
              <Row align="middle" className="records-row-mobile">
                <Col>
                  <Form.Item>
                    <TriStateCheckbox 
                      value={hasDepositFilter.value} 
                      onChange={(val) => updateLocalFilterValue("hasdeposit", val)}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label="С долгом">
                    <TriStateCheckbox 
                      value={hasDolgFilter.value} 
                      onChange={(val) => updateLocalFilterValue("hasdolg", val)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
            
            <Form.Item label="Тренер" className="client-filter-form-item">
              <Select mode="multiple" className="client-filter-select" value={userFilter.value} options={userFilter.options} onChange={(val) => updateLocalFilterValue("UserIds", val)}/>
            </Form.Item>
            <Form.Item label="Менеджер" className="client-filter-form-item">
              <Select mode="multiple" className="client-filter-select" value={managerFilter.value} options={managerFilter.options} onChange={(val) => updateLocalFilterValue("ManagerIds", val)}/>
            </Form.Item>
            <Button className="sport-btn" onClick={onSave} style={{ width: "100%" }}>ОК</Button>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ClientFilter;